import React, {FC, useState} from "react"
import IconButton from "@irati/ui/src/Button/IconButton"
import GenericModal from "@irati/ui/src/GenericModal"
import {IconTypes} from "@irati/ui/src/Icon"
import ModalContent from "./ModalContent"

const RewardsTriggerModal: FC = () => {
  const [show, setShow] = useState(false)
  const stopPropagation = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.stopPropagation() // Stop the propagation of the onclick to prevent the RouterLink to update the History
    e.preventDefault() // Stop the default behaviour of the href on the RouterLink
  }
  const showModal = () => setShow(true)
  const closeModal = () => setShow(false)
  return (
    <div onClick={stopPropagation}>
      <IconButton onClick={showModal} icon={IconTypes.circleQuestion} extraLarge />
      {show && (
        <GenericModal show={show} onHide={closeModal} hideActions>
          <ModalContent closeModal={closeModal} />
        </GenericModal>
      )}
    </div>
  )
}

export default RewardsTriggerModal
